import { ElementType, ReactNode } from "react";

import { BodyMD } from "./BodyMD";
import { cn } from "@verse_core/shared_components/ClassName";

type BodyProps = {
  children: ReactNode;
  className?: string;
  dataTestId?: string;
  as?: ElementType;
};

export const BodyMDB = ({
  children,
  className,
  as: Component = "p",
  dataTestId,
}: BodyProps) => {
  return (
    <BodyMD
      className={cn("tw-font-medium", className)}
      as={Component}
      dataTestId={dataTestId}
    >
      {children}
    </BodyMD>
  );
};
